export default __webpack_public_path__ + "static/media/notification.d10ed29c.svg";